var map = {
	"./authorize.svg": 1131,
	"./canceled.svg": 1132,
	"./capture.svg": 1133,
	"./card-authentication-line.svg": 1134,
	"./collect-card.svg": 1135,
	"./created.svg": 1136,
	"./failed.svg": 1137,
	"./processing.svg": 1138,
	"./requires-action-line.svg": 1139,
	"./requires-confirmation.svg": 1140,
	"./requires-payment-method.svg": 1141,
	"./succeeded.svg": 1142,
	"./verified.svg": 1143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1130;